export default "__VITE_ASSET__uTVW20Vw__"